// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export class RiskPlanMargin {
    constructor(Warning, Initial, Maintenance, Leverage) {
        this.Warning = Warning;
        this.Initial = Initial;
        this.Maintenance = Maintenance;
        this.Leverage = Leverage;
    }
    isEmpty() {
        return (this.isNumberEmpty(this.Warning) && this.isNumberEmpty(this.Initial) && this.isNumberEmpty(this.Maintenance));
    }
    isNumberEmpty(value) {
        return !isValidNumber(value) || value === 0;
    }
}
